import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

function SelectIDE() {

  const { lab_id } = useParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [selecting, setSelecting] = useState(false);
  const [selectedIDE, setSelectedIDE] = useState("");


  const createCheckoutSession = async (requestId) => {

    const apiKey = localStorage.getItem("api_key");

    const resp = await fetch(
      "/api/create-checkout-session",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": apiKey
        },
        body: JSON.stringify({
          lab_id: lab_id,
          ide_request_id: requestId
        })
      }
    );


    const data = await resp.json();
    if (!resp.ok) {
      throw new Error(
        data.error || "Checkout creation failed"
      );
    }
    // Redirect to Stripe Checkout
    window.location.href = data.checkout_url;
  };

  const handleSelect = async (ideType) => {

    setSelecting(true);
    setStatus("");
    setError("");
    try {
      const apiKey = localStorage.getItem("api_key");
      const resp = await fetch(
        "/api/ide/select",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": apiKey
          },
          body: JSON.stringify({
            lab_id: lab_id,
            ide_type: ideType
          })
        }
      );


      const data = await resp.json();
      if (!resp.ok) {
        throw new Error(
          data.error || "Failed to select IDE"
        );
      }
      setSelectedIDE(ideType);
      /*
        Advanced IDE requires payment
      */
      if (data.requires_payment) {
        setStatus(
          "Redirecting to payment..."
        );
        await createCheckoutSession(
          data.request_id
        );
        return;
      } else{
        window.location = "/rect/dash";
      }

      /*
        Simple IDE
      */

      setStatus(
        "Your Simple IDE request has been submitted. Waiting for administrator approval."
      );
    }

    catch(err){
      setError(err.message);
    }

    finally{
      setSelecting(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h1 className="fw-bold">
          Choose Your Development Environment
        </h1>
        <p className="text-muted fs-5">
          Select the IDE for your STEMX365 learning experience.
        </p>
      </div>
      <div className="row justify-content-center g-4">
        {/* SIMPLE IDE */}
        <div className="col-lg-5">
          <div className="card h-100 shadow border-0 rounded-4">
            <div className="card-body p-4">
              <div className="text-center">
                <i className="bi bi-laptop fs-1 text-primary"></i>
                <h3 className="mt-3 fw-bold">
                  Simple IDE
                </h3>
                <h2 className="text-success">
                  FREE
                </h2>
              </div>
              <ul className="list-group list-group-flush mb-4">
                <li className="list-group-item">
                  ✔ Browser-based editor
                </li>
                <li className="list-group-item">
                  ✔ Python programming
                </li>
                <li className="list-group-item">
                  ✔ Student projects
                </li>
                <li className="list-group-item">
                  ✔ Beginner friendly
                </li>
                <li className="list-group-item">
                  ✔ Admin approval required
                </li>
              </ul>
              <button
                className="btn btn-primary btn-lg w-100"
                disabled={selecting}
                onClick={() =>
                  handleSelect("simple")
                }
              >
                {selecting
                  ? "Processing..."
                  : "Request Simple IDE"}
              </button>
            </div>
          </div>
        </div>
        {/* ADVANCED IDE */}
        <div className="col-lg-5">
          <div className="card h-100 shadow-lg border-warning rounded-4">
            <div className="card-body p-4">
              <div className="text-center">
                <i className="bi bi-cpu-fill fs-1 text-warning"></i>
                <h3 className="mt-3 fw-bold">
                  Advanced Cloud IDE
                </h3>
                <h2 className="text-danger">
                  Premium
                </h2>
              </div>
              <ul className="list-group list-group-flush mb-4">
                <li className="list-group-item">
                  ✔ Full VS Code environment
                </li>
                <li className="list-group-item">
                  ✔ Docker container
                </li>
                <li className="list-group-item">
                  ✔ ROS / Astrobee simulation
                </li>
                <li className="list-group-item">
                  ✔ Jupyter Notebook
                </li>
                <li className="list-group-item">
                  ✔ Requires subscription
                </li>
              </ul>
              <button
                className="btn btn-warning btn-lg w-100"
                disabled={selecting}
                onClick={() =>
                  handleSelect("advanced")
                }
              >
                {selecting
                  ? "Processing..."
                  : "Subscribe Advanced IDE"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {status && (
        <div className="alert alert-success mt-5">
          {status}
        </div>
      )}
      {error && (
        <div className="alert alert-danger mt-5">
          {error}
        </div>
      )}
    </div>
  );
}
export default SelectIDE;